import ComingSoonPage from "./comingSoonPage"

export default ComingSoonPage;